export default "__VITE_ASSET__C$CVHH8Y__"